import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { toast } from 'sonner';

import { type ButtonProps, buttonVariants, cn } from '@cold-ambulance/shadcn';

import { useUser } from '../firebase.tsx';

export function NewRequestButton({
  variant,
  className,
  size,
  ...props
}: ButtonProps) {
  const { t } = useTranslation();
  const userQuery = useUser();
  const isApproved = userQuery.isPending
    ? true
    : (userQuery.data?.approved ?? false);

  if (!isApproved) {
    return (
      <button
        type="button"
        className={buttonVariants({
          variant: variant,
          className: cn('!h-11 px-6 opacity-50', className),
          size,
        })}
        onClick={() => toast.info(t('home.accountUnderReview'))}
      >
        {t('requests.newRequest')}
      </button>
    );
  }

  return (
    <Link
      to="/requests/new"
      className={buttonVariants({
        variant: variant,
        className: cn('!h-11 px-6', className),
        size,
        ...props,
      })}
    >
      {t('requests.newRequest')}
    </Link>
  );
}
